import { assets } from '../../config/assets'

export const carouselItems = [
  {
    id: 'thematic',
    image: assets.posters.thematic,
    titleKey: 'nav.thematicSubscriptions',
    to: '/subscriptions/thematic',
  },
  {
    id: 'personal',
    image: assets.posters.bespoke,
    titleKey: 'subscription.personal.title',
    to: '/subscription/personal',
  },
  {
    id: 'gifts',
    image: assets.posters.gift,
    titleKey: 'gifts.title',
    to: '/gifts',
  },
  {
    id: 'company',
    image: assets.posters.company,
    titleKey: 'nav.companyOffer',
    to: '/company',
  },
]
